export enum SettingLogTab {
  Business = 1,
  Page = 2,
}

export const TYPE_LOG_SETTING = {
  TYPE_CONVERSATION_SPLIT : 1,
  TYPE_AUTO_ECOM_CUSTOMER_CARE : 2,
  TYPE_TAGS_SETTING : 3,
  TYPE_QUICK_MESSAGE_SETTING : 4,
  TYPE_STAFF_SETTING : 5,
  TYPE_MARK_CONVERSATION : 6,
  TYPE_LOGIN: 8,
  TYPE_LOGOUT: 9,
  TYPE_CUSTOM_AUDIENCE_SETTING: 10,

  typeLogName: (type: number): string => typeof typesLogName[type] != 'undefined' ? typesLogName[type] : '',
} as const

export const TYPE_SUB_LOG_SETTING = {
  TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_GROUP : 2,
  TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_INDIVIDUAL : 3,
  TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_MANUAL : 4,
  TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_SHIFT : 5,
  TYPE_SUB_LOG_CONVERSATION_SPLIT_UPDATE_USER : 6,

  typeSubLogName: (type: number): string => typeof typesSubLogName[type] != 'undefined' ? typesSubLogName[type] : '',
} as const

export const TYPE_STEP_ACTION = {
  STEP_ENABLE: 1,
  STEP_DISABLE: 2,
  STEP_EDIT : 3,
  STEP_DELETE : 4,
  STEP_ADD: 5,
  STEP_REPLAY: 6,
  STEP_TICK: 7,

  typeStepName: (step: number): string => typeof typeStepLogName[step] != 'undefined' ? typeStepLogName[step] : '',
} as const

export const typesLogName: Record<number, string> = {
  [TYPE_LOG_SETTING.TYPE_CONVERSATION_SPLIT]: 'setting.logTypeConversationSplit',
  [TYPE_LOG_SETTING.TYPE_AUTO_ECOM_CUSTOMER_CARE]: 'setting.logTypeAutoEcomCustomerCare',
  [TYPE_LOG_SETTING.TYPE_TAGS_SETTING]: 'setting.logTypeTagsSetting',
  [TYPE_LOG_SETTING.TYPE_QUICK_MESSAGE_SETTING]: 'setting.logTypeQuickMessageSetting',
  [TYPE_LOG_SETTING.TYPE_STAFF_SETTING]: 'setting.staffSettings',
  [TYPE_LOG_SETTING.TYPE_MARK_CONVERSATION]: 'setting.logTypeMarkConversation',
  [TYPE_LOG_SETTING.TYPE_LOGIN]: 'setting.logTypeLogin',
  [TYPE_LOG_SETTING.TYPE_LOGOUT]: 'setting.logTypeLogout',
  [TYPE_LOG_SETTING.TYPE_CUSTOM_AUDIENCE_SETTING]: 'setting.logTypeCustomAudienceSetting',
}

export const typesSubLogName: Record<number, string> = {
  [TYPE_SUB_LOG_SETTING.TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_GROUP]: 'setting.splitConversation.byGroup',
  [TYPE_SUB_LOG_SETTING.TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_INDIVIDUAL]: 'setting.logSubTypeConversationSplitModeIndividual',
  [TYPE_SUB_LOG_SETTING.TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_MANUAL]: 'setting.splitConversation.manual',
  [TYPE_SUB_LOG_SETTING.TYPE_SUB_LOG_CONVERSATION_SPLIT_MODE_SHIFT]: 'setting.splitConversation.byShift',
  [TYPE_SUB_LOG_SETTING.TYPE_SUB_LOG_CONVERSATION_SPLIT_UPDATE_USER]: 'common.updateStaff',
}

export const typeStepLogName: Record<number, string> = {
  [TYPE_STEP_ACTION.STEP_ENABLE]: 'common.turnOn',
  [TYPE_STEP_ACTION.STEP_DISABLE]: 'common.turnOff',
  [TYPE_STEP_ACTION.STEP_EDIT]: 'common.edit',
  [TYPE_STEP_ACTION.STEP_DELETE]: 'common.delete',
  [TYPE_STEP_ACTION.STEP_ADD]: 'common.addNew',
  [TYPE_STEP_ACTION.STEP_REPLAY]: 'common.replace',
  [TYPE_STEP_ACTION.STEP_TICK]: 'common.tick',
}

export type SettingLogType =
  | typeof TYPE_LOG_SETTING.TYPE_CONVERSATION_SPLIT
  | typeof TYPE_LOG_SETTING.TYPE_AUTO_ECOM_CUSTOMER_CARE
  | typeof TYPE_LOG_SETTING.TYPE_TAGS_SETTING
  | typeof TYPE_LOG_SETTING.TYPE_QUICK_MESSAGE_SETTING
  | typeof TYPE_LOG_SETTING.TYPE_STAFF_SETTING
  | typeof TYPE_LOG_SETTING.TYPE_MARK_CONVERSATION
  | typeof TYPE_LOG_SETTING.TYPE_LOGIN
  | typeof TYPE_LOG_SETTING.TYPE_LOGOUT
  | typeof TYPE_LOG_SETTING.TYPE_CUSTOM_AUDIENCE_SETTING

export interface ISettingLogParams {
  tab: SettingLogTab,
  businessId?: number,
  pageIds?: string[],
  type?: SettingLogType | number,
  types?: number[],
  startDate?: number,
  endDate?: number,
  size?: number,
  next?: unknown[],
}

export interface ISettingLogItem {
  id: string,
  businessId: number,
  pageId: string,
  createdById?: string | number,
  createdByName?: string,
  role?: string | number,
  type: SettingLogType | number,
  dataBefore: string,
  dataAfter: string,
  clientIpAddress?: string | null,
  userAgent?: string | null,
  createdAt: number,
}

export interface ISettingLogListResponse {
  result: ISettingLogItem[],
  next: unknown[],
  totalItems: number,
}
